import { Attribute, booleanAttribute, Directive, HostBinding, Input, Output } from '@angular/core';

@Directive({
    selector: 'cs-icon',
    host: {
        role: 'img',
    },
    standalone: false
})
export class CsIconComponent {
  @Input() name: string;
  @Input({ transform: booleanAttribute }) fill: boolean = false;
  @Output('aria-label') get ariaLabel() {
    return this.name;
  }
  @HostBinding('class') get cssClass() {
    if (this.name) {
      return this.name;
    }
    return 'none';
  }
  @HostBinding('attr.fill') get fillAttr() {
    return this.fill || null;  // Add fill attribute when true
  }

  constructor(
    @Attribute('disabled') public disabled: boolean,
    @Attribute('mini') public mini: boolean,
  ) {}
}
